webpackJsonp([24,42],{

/***/ 16:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(19);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),

/***/ 1732:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_vue__ = __webpack_require__(1733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_default_index_css__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_css_reset_scss__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_css_reset_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_css_reset_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_css_common_scss__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_css_common_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_css_common_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_css_iconfont_css__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_css_iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_css_iconfont_css__);








__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  template: '<login/>',
  components: { login: __WEBPACK_IMPORTED_MODULE_2__index_vue___default.a }
});

/***/ }),

/***/ 1733:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1734)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(1735),
  /* template */
  __webpack_require__(1736),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1734:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1735:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_resource__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var LOGIN_TXT = '登录';
/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var checkName = function checkName(rule, value, callback) {
            if (!value) {
                return callback(new Error('请输入邮箱') /*this.$message.error('请输入邮箱！')*/);
            } else if (!/^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/.test(value)) {
                callback(new Error('请输入正确的邮箱'));
            } else {
                return callback();
            }
        };
        var checkPassword = function checkPassword(rule, value, callback) {
            if (!value) {
                return callback(new Error('请输入密码') /*this.$message.error('请输入登录密码！')*/);
            } else {
                return callback();
            }
        };
        var checkCode = function checkCode(rule, value, callback) {
            if (!value) {
                return callback(new Error('请输入验证码') /*this.$message.error('请输入验证码！')*/);
            } else {
                return callback();
            }
        };
        return {
            form: {
                name: '',
                password: '',
                code: ''
            },
            focus: {
                name: false,
                password: false,
                code: false
            },
            showCode: false,
            loading: false,
            imgSrc: '',
            loginText: LOGIN_TXT,
            rules: {
                name: [{ validator: checkName, trigger: 'blur,change' }],
                password: [{ validator: checkPassword, trigger: 'blur,change' }],
                code: [{ validator: checkCode, trigger: 'blur,change' }]
            }
        };
    },

    directives: {
        focus: {
            inserted: function inserted(el, binding) {
                if (binding.value) {
                    el.children[0].focus();
                }
            },
            update: function update(el, binding) {
                if (binding.value && binding.oldValue != binding.value) {
                    el.children[0].focus();
                }
            }
        }
    },
    methods: {
        onSubmit: function onSubmit(formName) {
            var _this = this;

            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    _this.loading = true;
                    _this.loginText = '';
                    var params = {
                        username: _this.form.name,
                        password: _this.form.password,
                        code: _this.form.code
                    };
                    __WEBPACK_IMPORTED_MODULE_0__common_resource__["default"].user_signIn(params, null).then(function (response) {
                        if (response.body.success) {
                            window.location.href = '/butterfly/admin';
                        } else {
                            _this.$message.error(response.body.message); //'邮箱或密码错误';
                            _this.showCode = true;
                            _this.form.code = '';
                            _this.imgSrc = __WEBPACK_IMPORTED_MODULE_0__common_resource__["requestPrefix"] + '/captcha.png?' + new Date().getTime();
                            _this.loading = false;
                            _this.loginText = LOGIN_TXT;
                        }
                    }, function (response) {
                        _this.loading = false;
                        _this.loginText = LOGIN_TXT;
                        _this.$message.error('邮箱或密码错误');
                        _this.form.code = '';
                        _this.imgSrc = __WEBPACK_IMPORTED_MODULE_0__common_resource__["requestPrefix"] + '/captcha.png?' + new Date().getTime();
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        refreshImg: function refreshImg() {
            this.imgSrc = __WEBPACK_IMPORTED_MODULE_0__common_resource__["requestPrefix"] + '/captcha.png?' + new Date().getTime();
        },
        inputFocus: function inputFocus(arg) {
            for (var key in this.focus) {
                this.focus[key] = false;
            }
            this.focus[arg] = true;
        },
        inputBlur: function inputBlur(arg) {
            if (this.form[arg] == '' || this.form[arg] == undefined) {
                this.focus[arg] = false;
            }
        },
        clearText: function clearText(arg) {
            this.form[arg] = '';
        }
    }
});

/***/ }),

/***/ 1736:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Lite CRM")]), _vm._v(" "), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(686)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('img', {
    staticClass: "admin",
    attrs: {
      "src": __webpack_require__(1737),
      "height": "196",
      "width": "156"
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticClass: "myForm",
    attrs: {
      "model": _vm.form,
      "label-width": "0",
      "rules": _vm.rules,
      "show-message": true
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onSubmit('form')
      }
    }
  }, [_c('el-form-item', {
    class: {
      'focus': _vm.focus.name
    },
    attrs: {
      "prop": "name"
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.inputFocus('name')
      }
    }
  }, [_c('el-input', {
    directives: [{
      name: "focus",
      rawName: "v-focus",
      value: (_vm.focus.name),
      expression: "focus.name"
    }],
    on: {
      "blur": function($event) {
        return _vm.inputBlur('name')
      }
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "placeholder",
    class: {
      'inner-empty': _vm.form.name == ''
    },
    on: {
      "click": function($event) {
        return _vm.inputFocus('name')
      }
    }
  }, [_vm._v("邮箱")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.name != ''),
      expression: "form.name!=''"
    }],
    staticClass: "el-icon-close",
    on: {
      "click": function($event) {
        return _vm.clearText('name')
      }
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    class: {
      'focus': _vm.focus.password
    },
    attrs: {
      "prop": "password"
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.inputFocus('password')
      }
    }
  }, [_c('el-input', {
    directives: [{
      name: "focus",
      rawName: "v-focus",
      value: (_vm.focus.password),
      expression: "focus.password"
    }],
    attrs: {
      "type": "password"
    },
    on: {
      "blur": function($event) {
        return _vm.inputBlur('password')
      }
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "placeholder",
    class: {
      'inner-empty': _vm.form.password == ''
    },
    on: {
      "click": function($event) {
        return _vm.inputFocus('password')
      }
    }
  }, [_vm._v("密码")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.password != ''),
      expression: "form.password!=''"
    }],
    staticClass: "el-icon-close",
    on: {
      "click": function($event) {
        return _vm.clearText('password')
      }
    }
  })], 1)]), _vm._v(" "), (_vm.showCode) ? _c('el-form-item', {
    class: {
      'focus': _vm.focus.code
    },
    attrs: {
      "prop": "code"
    }
  }, [_c('el-row', {
    staticClass: "code-item"
  }, [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.inputFocus('code')
      }
    }
  }, [_c('el-input', {
    directives: [{
      name: "focus",
      rawName: "v-focus",
      value: (_vm.focus.code),
      expression: "focus.code"
    }],
    on: {
      "blur": function($event) {
        return _vm.inputBlur('code')
      }
    },
    model: {
      value: (_vm.form.code),
      callback: function($$v) {
        _vm.$set(_vm.form, "code", $$v)
      },
      expression: "form.code"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "placeholder",
    class: {
      'inner-empty': _vm.form.code == ''
    },
    on: {
      "click": function($event) {
        return _vm.inputFocus('code')
      }
    }
  }, [_vm._v("验证码")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.code != ''),
      expression: "form.code!=''"
    }],
    staticClass: "el-icon-close",
    on: {
      "click": function($event) {
        return _vm.clearText('code')
      }
    }
  })], 1)]), _vm._v(" "), _c('img', {
    staticClass: "code-img",
    attrs: {
      "src": _vm.imgSrc,
      "width": "126px",
      "height": "48px"
    },
    on: {
      "click": _vm.refreshImg
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-button', {
    staticClass: "submit",
    attrs: {
      "loading": _vm.loading,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit('form')
      }
    }
  }, [_vm._v(_vm._s(_vm.loginText))]), _vm._v(" "), _c('p', {
    staticClass: "forget",
    attrs: {
      "onclick": "window.location.href='/butterfly/admin/sign-in/forgetPwd.html'"
    }
  }, [_vm._v("忘记密码?")])], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 1737:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cd84851405e7b94f6551e73253077780.png";

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 283:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 29:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = options.computed || (options.computed = {})
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 4:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "requestPrefix", function() { return requestPrefix; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(16);



__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

var requestPrefix = 'https://haiyun.hikoon.com:8446/manager';
//  export const requestPrefix = 'https://testtomcat.hikoon.com/butterfly-haiyun';
//  export const requestPrefix = 'http://127.0.0.1:8081/butterfly_web_war_exploded';


__WEBPACK_IMPORTED_MODULE_0_vue___default.a.http.interceptors.push(function (request, next) {
  // console.log('admin',request.url.replace('market', 'manager'))
  // request.url = request.url.replace('market', 'manager');
  if (request.url.indexOf(requestPrefix) < 0) {
    request.url = requestPrefix + request.url;
  }
  next(function (response) {
    if (response.status === 401) {
      window.top.location.href = '/butterfly/admin/sign-in/index.html';
    }
  });
});

var actions = {

  /*交易管理*/
  admin_order_query: { method: 'POST', url: '/order' }, // 查询我的订购
  admin_order_op: { method: 'POST', url: '/order/op/{opType}' }, // 订单操作
  admin_get_order: { method: 'GET', url: '/order/{orderId}' }, // 获取
  admin_order_change_price: { method: 'POST', url: '/order/changePrice' }, // 获取
  admin_get_order_trace: { method: 'GET', url: '/order/orderTrace/{orderId}' }, // 获取
  admin_order_signed: { method: 'POST', url: '/order/signed', emulateJSON: true }, // 订单完成签约

  admin_get_customer: { method: 'GET', url: '/customers/{id}' }, // 获取

  /*个人首页*/
  admin_get_statistics: { method: 'GET', url: '/order/statistics' }, //获取统计信息

  /* 登录 退出*/
  user_signIn: { method: 'POST', url: '/login' }, // 登录
  user_signOut: { method: 'POST', url: '/cust-logout' }, // 注销

  /*后台-经纪人*/
  users_manager_search: { method: 'POST', url: '/users', emulateJSON: true }, // 经纪人管理
  users_manager_sendEmail: { method: 'POST', url: '/user/{id}/activationMail', emulateJSON: true }, // 经纪人发送邮件
  users_manager_disable: { method: 'GET', url: '/user/disable/{id}' }, //禁用
  users_manager_enable: { method: 'GET', url: '/user/enable/{id}' }, //启用
  users_manager_deleteUser: { method: 'GET', url: '/user/delete/{id}' }, //删除

  users_myprofile: { method: 'GET', url: '/user/myprofile' }, //登录用户的资料
  users_modify_password: { method: 'POST', url: '/user/my/password' }, //登录用户的资料
  users_modify_phone: { method: 'POST', url: '/user/my/phone' }, //登录用户的资料
  users_modify_nickname: { method: 'POST', url: '/user/my/nickname', emulateJSON: true }, //登录用户的资料

  user_tokenValid: { method: 'GET', url: '/user/token/valid', emulateJSON: true }, // 验证激活码
  user_activation: { method: 'PUT', url: '/user/{id}/activation' }, // 激活


  users_manager_add: { method: 'POST', url: '/users/create', emulateJSON: true }, // 创建经纪人
  users_manager_searchById: { method: 'GET', url: '/users/{id}' }, // 经纪人明细
  users_manager_edit: { method: 'POST', url: '/users/modify', emulateJSON: true }, // 更新经纪人
  /*后台-客户*/
  customer_manager_search: { method: 'POST', url: '/customers', emulateJSON: true }, // 客户管理
  customer_manager_sendEmail: { method: 'GET', url: '/customer/{id}/email/resend' }, // 客户发送邮件
  customer_manager_disable: { method: 'GET', url: '/customer/disable/{id}' }, //禁用
  customer_manager_enable: { method: 'GET', url: '/customer/enable/{id}' }, //启用
  customer_manager_deleteCustomer: { method: 'GET', url: '/customer/delete/{id}' }, //删除

  customer_manager_add: { method: 'POST', url: '/customers/create', emulateJSON: true }, // 创建客户
  customer_manager_add2: { method: 'POST', url: '/customers/create2' }, // 创建客户
  customer_manager_searchById: { method: 'GET', url: '/customers/{id}' }, // 客户明细
  customer_manager_edit: { method: 'POST', url: '/customers/modify', emulateJSON: true }, // 更新客户
  customer_manager_edit2: { method: 'POST', url: '/customers/modify2' }, // 更新客户

  /*后台-作品管理*/
  song_manager_search: { method: 'POST', url: '/song/menagement', emulateJSON: true }, // 作品管理
  song_manager_batch_operate: { method: 'POST', url: '/song/batch/operation', emulateJSON: true }, // 批量操作
  song_manager_song_onsell: { method: 'GET', url: '/song/onsell/{id}' },
  song_manager_song_offsell: { method: 'POST', url: '/song/offsell', emulateJSON: true },
  song_manager_song_delete: { method: 'GET', url: '/song/delete/{id}' },
  song_manager_song_searchById: { method: 'GET', url: '/song/detail/{id}' },
  song_manager_song_submit: { method: 'POST', url: '/song', emulateJSON: true },
  song_manager_tag: { method: 'GET', url: '/song/tags' },
  song_musician_list: { method: 'GET', url: '/song/musician' },
  new_song_id: { method: 'GET', url: '/song/id' },
  song_lrc: { method: 'GET', url: '/song/lrc/{vendorId}/{id}', emulateJSON: true }, // 歌词
  song_desc: { method: 'GET', url: '/song/creation/{vendorId}/{id}', emulateJSON: true }, // 创作说明
  song_export_title: { method: 'GET', url: '/songExport/title', emulateJSON: true }, // 导出列数据返回

  /*后台-服务管理*/
  new_service_id: { method: 'GET', url: '/song/id' },
  service_manager_service_submit: { method: 'POST', url: '/service', emulateJSON: true },
  service_manager_search: { method: 'POST', url: '/service/management', emulateJSON: true },
  service_manager_service_onsell: { method: 'POST', url: '/service/onsell', emulateJSON: true },
  service_manager_service_offsell: { method: 'POST', url: '/service/offsell', emulateJSON: true },
  service_manager_service_delete: { method: 'POST', url: '/service/delete', emulateJSON: true },
  service_manager_batch_operate: { method: 'POST', url: '/service/batch/operation', emulateJSON: true },
  service_manager_searchById: { method: 'GET', url: '/service/detail/{id}' },

  /*后台-待入库作品管理*/
  original_song_manager_search: { method: 'POST', url: '/original/song/menagement', emulateJSON: true },
  original_song_manager_searchById: { method: 'GET', url: '/creation/song/detail/{id}' },
  original_song_manager_approve: { method: 'POST', url: '/original/song/approved', emulateJSON: true },
  original_song_manager_batch_approval: { method: 'POST', url: '/original/song/batch/approved', emulateJSON: true },
  original_song_manager_unapprove: { method: 'POST', url: '/original/song/unapprove', emulateJSON: true },
  original_song_manager_batch_disapproval: { method: 'POST', url: '/original/song/batch/unapprove', emulateJSON: true },
  original_song_manager_cancelSign: { method: 'POST', url: '/original/song/cancel', emulateJSON: true },
  original_song_manager_sign: { method: 'POST', url: '/original/song/signing', emulateJSON: true },
  original_song_lrc: { method: 'GET', url: '/original/song/lrc/{vendorId}/{id}', emulateJSON: true }, // 歌词
  original_song_desc: { method: 'GET', url: '/original/song/creation/{vendorId}/{id}', emulateJSON: true }, // 创作说明

  /* 后台-词曲人管理 */
  application_search: { method: 'GET', url: '/application/list' }, // 待入驻词曲人查询
  application_detail: { method: 'GET', url: '/application/{id}' }, // 待入驻词曲人详情
  application_approval: { method: 'POST', url: '/application/approval/{id}' }, // 审核通过
  application_agreemenet: { method: 'POST', url: '/application/agreement/{id}' }, // 完成签约
  musician_contract: { method: 'POST', url: '/contract/musician/{musicianId}', emulateJSON: true }, // 词曲人签约

  musician_list: { method: 'POST', url: '/musician', emulateJSON: true }, //词曲人查询
  musician_manager_sendEmail: { method: 'POST', url: '/musician/{id}/activationMail', emulateJSON: true }, // 经纪人发送邮件
  musician_manager_enable: { method: 'GET', url: '/musician/enable/{id}' }, //启用
  musician_manager_disable: { method: 'GET', url: '/musician/disable/{id}' }, //禁用
  musician_manager_deleteUser: { method: 'GET', url: '/musician/delete/{id}' }, //删除
  musician_manager_create: { method: 'POST', url: '/musician/create' }, //新建词曲人
  musician_get: { method: 'GET', url: '/musician/{id}' }, //新建词曲人
  musician_modify: { method: 'POST', url: '/musician/modify' }, //新建词曲人
  musician_get_masterwork: { method: 'GET', url: '/musician/masterworks/{id}' }, //新建词曲人
  musician_export_title: { method: 'GET', url: '/musicianExport/title', emulateJSON: true }, // 导出列数据返回

  /* 回购作品 */
  buyback_orders: { method: 'POST', url: '/buybackorders' }, //查询回购单
  buyback_detail: { method: 'GET', url: '/buybackorders/{orderId}' }, // 回购单详情
  /* 公告 */
  notice_search: { method: 'POST', url: '/notice/search' }, // 查询公告
  notice_create: { method: 'POST', url: '/notice/create' }, // 创建公告
  notice_edit: { method: 'POST', url: '/notice/edit/{noticeId}' }, // 编辑公告
  notice_delete: { method: 'POST', url: '/notice/delete/{noticeId}' }, // 删除公告
  notice_detail: { method: 'GET', url: '/notice/{noticeId}' }, // 公告详情
  notices: { method: 'GET', url: '/notice/alldisplay' }, // 获取公告
  /* 忘记密码 */
  user_forgetPwd: { method: 'POST', url: '/user/forgotpassword' }, // 验证邮箱
  user_validresetcode: { method: 'POST', url: '/user/validresetcode' }, // 验证token
  user_resetpassword: { method: 'POST', url: '/user/resetpassword' }, // 设置新密码
  /* 合同 */
  contract_id: { method: 'GET', url: '/contract/id' }, //获取合同ID
  contract_song: { method: 'POST', url: '/contract/song', emulateJSON: true }, // 作品签约
  contract_management: { method: 'POST', url: '/contract/management', emulateJSON: true }, // 合同管理
  contract_detail: { method: 'GET', url: '/contract/{id}' }, // 合同详情
  contract_preview: { method: 'GET', url: '/contract/preview/{id}' }, // 合同预览
  contract_download: { method: 'GET', url: '/contract/download/{id}' }, // 合同下载
  contract_cancel: { method: 'POST', url: '/contract/cancel', emulateJSON: true }, // 撤销合同
  contract_buyback: { method: 'POST', url: '/contract/buyback', emulateJSON: true }, // 回购下发合同

  /* 后台 */
  admin_get_case: { method: 'POST', url: '/bestCaseSongs/pageall' }, //获取优秀案例列表
  admin_add_case: { method: 'POST', url: '/bestCaseSongs/add' }, //新增优秀案例
  admin_update_case: { method: 'POST', url: '/bestCaseSongs/update' }, //修改优秀案例
  admin_delete_case: { method: 'POST', url: '/bestCaseSongs/delete' }, //删除优秀案例
  admin_detail_case: { method: 'GET', url: '/bestCaseSongs/detail/{id}', emulateJSON: true }, //优秀案例详情

  admin_get_artist: { method: 'POST', url: '/coEntertainers/pagelist' }, //获取合作艺人列表
  admin_add_artist: { method: 'POST', url: '/coEntertainers/add' }, //新增合作艺人
  admin_update_artist: { method: 'POST', url: '/coEntertainers/update' }, //修改合作艺人
  admin_delete_artist: { method: 'POST', url: '/coEntertainers/delete' }, //删除合作艺人
  admin_detail_artist: { method: 'GET', url: '/coEntertainers/detail/{id}', emulateJSON: true }, //合作艺人详情

  admin_get_musician: { method: 'POST', url: '/musician/supplier/list' }, //获取供应商列表

  admin_add_musician: { method: 'POST', url: '/musician/supplier/save' }, //新增供应商
  admin_update_musician: { method: 'POST', url: '/musician/supplier/save' }, //修改供应商
  admin_get_musician_by_id: { method: 'get', url: '/musician/supplier/{id}' }, //查询单个供应商
  admin_del_musician: { method: 'get', url: '/musician/supplier/del/{id}' }, //删除供应商
  admin_connection_musician: { method: 'POST', url: '/musician/supplier/connection' }, //供应商关联艺人

  admin_get_musician_by_name: { method: 'POST', url: '/musician', emulateJSON: true }, //搜索合作艺人
  admin_get_log_module: { method: 'get', url: '/operationLog/module', emulateJSON: true }, //获取系统日志操作模块
  admin_get_log: { method: 'POST', url: '/operationLog/operationDate', emulateJSON: true }, //获取系统日志操作
  admin_recommendation_create: { method: 'POST', url: '/admin/recommendation/create' }, // 新增或修改音乐推荐任务
  admin_recommendation_get: { method: 'POST', url: '/admin/recommendation/list' }, // 获取推荐音乐列表

  admin_recommendation_suspend: { method: 'get', url: '/admin/recommendation/suspend/{id}' }, //暂停推荐
  admin_recommendation_resume: { method: 'get', url: '/admin/recommendation/resume/{id}' }, //恢复推荐
  admin_recommendation_cancel: { method: 'get', url: '/admin/recommendation/cancel/{id}' }, //取消推荐

  admin_musician_renew: { method: 'POST', url: '/contract/musicianRenew' }, //词曲人续约
  admin_recommendation_review: { method: 'POST', url: '/musician/recommendation/review' }, //审核词曲人的推荐申请
  admin_contract_refresh: { method: 'get', url: '/contract/refresh' }, //待入库作品手动刷新合同状态
  admin_offOrder_get: { method: 'POST', url: '/offOrder/list', emulateJSON: true }, // 下架中的作品
  admin_offOrder_refuse: { method: 'get', url: '/offOrder/refuse' }, //拒绝下架申请
  admin_offOrder_success: { method: 'get', url: '/offOrder/success' }, //通过下架申请
  admin_offOrder_detail: { method: 'get', url: '/offOrder/detail' }, //下架申请歌曲详情

  admin_get_mymenu_list: { method: 'GET', url: '/sys/user/menu/mymenu' }, // 获取当前用户的菜单列表
  admin_get_menu_list: { method: 'GET', url: '/sys/user/menu/list' }, // 获取全部菜单列表
  admin_get_role_list: { method: 'GET', url: '/sys/user/role/list' }, // 获取角列表
  admin_delete_role: { method: 'GET', url: '/sys/user/role/del/{id}' }, // 删除角色
  admin_find_role: { method: 'GET', url: '/sys/user/role/find/{id}' }, // 角色详情
  admin_save_update_role: { method: 'POST', url: '/sys/user/role/saveOrUpdate' }, // 添加/编辑角色
  admin_save_update_menu: { method: 'POST', url: '/sys/user/menu/saveOrUpdate' }, // 添加/编辑菜单


  admin_audition_add: { method: 'POST', url: '/audition/initiate', emulateJSON: true }, // 发起试听
  admin_audition_list: { method: 'POST', url: '/audition/list', emulateJSON: true }, // 试听会列表

  admin_updateFormerName: { method: 'POST', url: '/song/updateFormerName', emulateJSON: true }, // 更改歌曲名字
  admin_audition_auditionDetail: { method: 'GET', url: '/audition/auditionDetail?id={id}' }, // 试听会详情
  admin_audition_firstList: { method: 'GET', url: '/audition/firstList?id={id}' }, // 试听会初审列表
  admin_audition_checkAuditStatus: { method: 'GET', url: '/audition/checkAuditStatus' }, //实时查看试听会歌曲审核状态
  admin_audition_firstAudit: { method: 'POST', url: '/audition/firstAudit', emulateJSON: true }, // 初审
  admin_audition_endAudit: { method: 'GET', url: '/audition/endAudit?id={id}' }, //结束试听会
  admin_audition_finalList: { method: 'GET', url: '/audition/finalList?id={id}' }, // 试听会终审列表
  admin_audition_checkToFinalAudition: { method: 'GET', url: '/audition/checkAudition?id={id}' }, // 手动改为待终审
  admin_audition_finalAudit: { method: 'POST', url: '/audition/finalAudit', emulateJSON: true }, // 终审
  admin_customerView_totalData: { method: 'GET', url: '/customerView/totalData' }, // 客户总览数据
  admin_customerView_customerData: { method: 'GET', url: '/customerView/customerData' }, // 客户视图数据
  admin_audition_secondAudit: { method: 'POST', url: '/audition/secondAudit', emulateJSON: true }, // 二审
  admin_audition_secondList: { method: 'GET', url: '/audition/secondList?id={id}' }, // 试听会二审列表

  song_repeatNameCheck: { method: 'GET', url: '/song/repeatNameCheck?name={name}' }, // 歌曲名重复判断(海酝使用接口)

  //歌单
  sheet_list: { method: 'POST', url: '/sheet/list', emulateJSON: true }, // 歌单列表
  sheet_changeStatus: { method: 'POST', url: '/sheet/changeStatus', emulateJSON: true }, // 歌单上架/下架/删除
  sheet_detail: { method: 'GET', url: '/sheet/detail?id={id}' }, // 歌单详情
  sheet_fileUpload: { method: 'POST', url: '/sheet/fileUpload', emulateJSON: true }, // 歌单封面上传
  sheet_image: { method: 'GET', url: '/sheet/image/{sheetId}' }, // 歌单封面下载
  sheet_addOrUpdate: { method: 'POST', url: '/sheet/addOrUpdate' }, // 新增歌单/修改歌单
  sheet_deleteSongs: { method: 'POST', url: '/sheet/deleteSongs', emulateJSON: true }, // 移除歌单中的歌曲
  // sheet_addSongs: {method: 'POST', url: '/sheet/addSongs',emulateJSON: true}, // 新增歌单中的歌曲
  sheet_addSongsList: { method: 'POST', url: '/sheet/addSongsList', emulateJSON: true } // 新增歌单中的歌曲列表
};

var resource = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.resource('', {}, actions, { credentials: true });

/* harmony default export */ __webpack_exports__["default"] = (resource);

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 44:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 686:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b5e26c784c29bbdb5d52f5ba087b752d.png";

/***/ })

},[1732]);


// WEBPACK FOOTER //
// admin/sign-in?350e49a4e7c325e358e8